import { useLazyQuery, useQuery } from "@apollo/client";
import { WAREHOUSE } from "../warehouse.queries";
import { WarehouseQuery, WarehouseQueryVariables } from "../../../__generated__/WarehouseQuery";

export const useWarehouse = (id: number) => {
  return useQuery<WarehouseQuery, WarehouseQueryVariables>(WAREHOUSE, { variables: { id } });
};

export const useLazyWarehouse = () => {
  return useLazyQuery<WarehouseQuery, WarehouseQueryVariables>(WAREHOUSE);
};
